export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS'
export const TABLE_VIEWS_LIST_FETCH_REQUESTED = 'TABLE_VIEWS_LIST_FETCH_REQUESTED'
export const TABLE_VIEWS_LIST_FETCH_SUCCESS = 'TABLE_VIEWS_LIST_FETCH_SUCCESS'
export const TABLE_VIEWS_SAVE_REQUESTED = 'TABLE_VIEWS_SAVE_REQUESTED'
export const TABLE_VIEWS_SAVE_SUCCESS = 'TABLE_VIEWS_SAVE_SUCCESS'
export const TABLE_VIEW_FETCH_REQUESTED = 'TABLE_VIEW_FETCH_REQUESTED'
export const TABLE_VIEW_FETCH_SUCCESS = 'TABLE_VIEW_FETCH_SUCCESS'
export const PROPOSAL_REVIWEWERS_FETCH_REQUESTED = 'PROPOSAL_REVIWEWERS_FETCH_REQUESTED'
export const PROPOSAL_REVIWEWERS_FETCH_SUCCESS = 'PROPOSAL_REVIWEWERS_FETCH_SUCCESS'
export const TABLE_VIEW_DELETE_REQUESTED = 'TABLE_VIEW_DELETE_REQUESTED'
export const TABLE_VIEW_DELETE_SUCCESS = 'TABLE_VIEW_DELETE_SUCCESS'
export const TABLE_VIEWS_LIST_RESET = 'TABLE_VIEWS_LIST_RESET'
